import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { func } from 'prop-types';
import DateRangeTable from './date-range-table';
import UnassignDeviceTable from './unassign-device-table';

/**
 * Renders project warning dialog.
 * @returns {React.FC}
 */

const ProjectWarning = props => {
  const {
    endDateWarnProjects,
    unassignDeviceWarnProjects,
    onAccept,
    onCancel
  } = props;

  return (
    <Dialog
      open={!!endDateWarnProjects?.length || !!unassignDeviceWarnProjects?.length}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        style={{
          backgroundColor: '#face31'
        }}
      >
        Updating project
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{
            marginTop: '8px'
          }}
        />
        <strong>Please review the changes</strong>
        <br />
        {!!endDateWarnProjects?.length &&
          <DateRangeTable projectsToChange={endDateWarnProjects} /> }
        {!!unassignDeviceWarnProjects?.length &&
          <UnassignDeviceTable projectsToChange={unassignDeviceWarnProjects} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={onAccept} color="primary" autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ProjectWarning.propTypes = {
  onAccept: func,
  onCancel: func

};

export default ProjectWarning;
